import { createReducer, getUpdater } from '@advanza/advanza_generic'
import { changeEntity, changeFilter, invalidateFilters, receiveList } from './sharedReducerHandlers'

const update = getUpdater()

const handlers = {
    BANS_RECEIVE_LIST: receiveList,
    BANS_CHANGE_FILTER: changeFilter,
    CHANGE_ENTITY_BANS: changeEntity,
    INVALIDATE_BANS: invalidateFilters,
    BANS_REQUEST: (state) =>
        update(state, {
            isFetching: { $set: true },
        }),
}

const initialState = {
    isFetching: false,
    didInvalidate: false,
    counts: {},
    entities: {},
    result: {},
    filters: {},
}

export default createReducer(initialState, handlers)
